import { Box, Typography } from "@mui/material";
import { principlePresentation, type PrincipleSignal } from "@chessla/shared";
import { PrincipleGlyph, StatusBadge } from "@/shared/components";

export const PrincipleSignalBadge = ({ signal }: { signal: PrincipleSignal }) => {
  const presentation = principlePresentation(signal.principle);
  const status = signal.status === "missed" ? "Missed" : "Applied";
  return (
    <Box
      component="span"
      role="img"
      data-principle-status={signal.status}
      aria-label={`${status} principle: ${presentation.name} — ${presentation.traditionalName}`}
      title={`${presentation.traditionalName} · ${presentation.cue}`}
      sx={{ display: "inline-flex" }}
    >
      <StatusBadge
        tone={signal.status === "missed" ? "missed" : "neutral"}
        label={
          <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.45 }}>
            <Box component="span" sx={{ display: "grid", placeItems: "center", width: 13, height: 13 }}>
              <PrincipleGlyph principle={signal.principle} />
            </Box>
            <Typography
              component="span"
              sx={{ color: "inherit", fontSize: "inherit", fontWeight: "inherit", lineHeight: 1 }}
            >
              {presentation.name}
            </Typography>
          </Box>
        }
      />
    </Box>
  );
};
